import axios from 'axios'
import store from '@/store'
import router from '@/router/index'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import {tipmessage} from "./index";

//本地服务器接口
const localServer = axios.create({
  baseURL: "/local",
  timeout: 20000//这里修改代码为15秒
})

//本地请求拦截器
localServer.interceptors.request.use(
  config => {
    if(store.getters.token){
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

//本地响应拦截器
localServer.interceptors.response.use(
  response => {
    const res = response.data;
    // 先判断响应是否为blob文件
    if(res instanceof Blob){
      if(response.headers['content-type'].indexOf('application/json') != -1 ){
        let reader = new FileReader(res);
        reader.onload = () => {
          let {result} = reader;
          let resjson = JSON.parse(result);
          tipmessage(resjson.msg,'error',1500);
        }
        reader.onerror = err => {
          return Promise.reject(err)
        }
        reader.readAsText(res);
        return Promise.reject(res)
      }else {
        return Promise.resolve(res);
      }
    }else{
      // 响应成功
      if(res.meta.status == 200){
        return Promise.resolve(res.data);
      }
      // token过期了
      if(res.meta.status == 422){
        tipmessage('您的登录Token已失效，即将跳转到登陆页面','error',1500);
        setTimeout(() => {
          store.dispatch('user/logout').then(()=> {
            router.push({path: "/"})
          })
        },1000)
      }else {
        return Promise.reject(res);
      }
    }
  },
  error => {
    return Promise.reject(error)
  }
)
//默认输出
export default localServer



// WEBPACK FOOTER //
// ./src/utils/request.js